import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

import Dashboard from "@/capital77/pages/MainView.vue";
import EditOwnInformation from "@/capital77/pages/EditProfileForm.vue";
import MyDocuments from "@/capital77/pages/MyDocuments.vue";
import Client from "@/capital77/pages/EditClientForm.vue";
import Credit from "@/capital77/pages/EditCreditForm.vue";
import MessagePage from "@/capital77/pages/MessagePage.vue";
import PasswordReset from "@/capital77/pages/PasswordReset.vue";
import CreateTicket from "@/capital77/pages/TicketForm.vue";
import EditTicket from "@/capital77/pages/EditTicketForm.vue";
import Categories from "@/capital77/pages/ClientCategory.vue";
import Login from "@/capital77/pages/Login.vue";
import RegisterAccount from "@/capital77/pages/WizardRegisterAccount.vue";
import RegisterProfile from "@/capital77/pages/WizardRegisterProfile.vue";
import HowItWorks from "@/capital77/pages/HowItWorks.vue";
import ClientCredits from "@/capital77/pages/ClientCredits.vue";
import ClientList from "@/capital77/pages/ClientList.vue";
import ClientTickets from "@/capital77/pages/ClientTickets.vue";

let authPages = {
  path: "/",
  component: AuthLayout,
  redirect: "/dashboard",
  name: "Authentication",
  children: [
    {
      path: "dashboard",
      name: "Inicio",
      components: { default: Dashboard }
    },
    {
      //purpose es la página a la que quiere redirigir después de iniciar sesión. Si tiene "/"", se debe poner " " en su lugar. Se debe incluir el " " del inicio, ej: /login/ hola mundo
      path: "/login/:purpose?",
      name: "Login",
      component: Login
    },

    {
      path: "/categories",
      name: "Categorías",
      component: Categories
    },

    {
      path: "messagePage/:purpose/:value?",
      name: "Notificación",
      components: { default: MessagePage }
    },
    {
      path: "passwordReset/:token",
      name: "Recuperación de contraseña",
      components: { default: PasswordReset }
    },
    {
      path: "how-it-works",
      name: "Funcionamiento",
      components: { default: HowItWorks }
    }
  ]
};

const routes = [
  authPages,

  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "/",
        redirect: "/dashboard",
        name: "Inicio"
      },
      {
        path: "credit-list",
        name: "Lista de Créditos",
        components: { default: ClientCredits }
      },
      {
        path: "/register-account",
        name: "Registro de Cuenta",
        component: RegisterAccount
      },
      {
        path: "register-profile",
        name: "Registro de Perfil",
        components: { default: RegisterProfile }
      },
      {
        path: "edit-own",
        name: "Actualizar Datos",
        components: { default: EditOwnInformation }
      },
      {
        path: "documents",
        name: "Mis Documentos",
        components: { default: MyDocuments }
      },
      {
        path: "client/:clientId",
        name: "Cliente",
        components: { default: Client }
      },
      {
        path: "credit/:creditId",
        name: "Crédito",
        components: { default: Credit }
      },
      {
        path: "edit-ticket/:ticketCode",
        name: "Ticket",
        components: { default: EditTicket }
      },
      {
        path: "clients",
        name: "Lista de Clientes",
        components: { default: ClientList }
      },
      {
        path: "tickets",
        name: "Lista de Tickets",
        components: { default: ClientTickets }
      },
      {
        path: "create-ticket",
        name: "Crear Ticket",
        components: { default: CreateTicket }
      }
    ]
  }
];

export default routes;
